var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgArrowRightGrey14 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 14,
  height: 8,
  viewBox: "0 0 14 8"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#6e6e6e",
  fillRule: "evenodd",
  d: "M8.78 6.823 9.984 8.03 14 4.015 9.985 0 8.78 1.206l1.956 1.956H0v1.706h10.735z"
})));
export default SvgArrowRightGrey14;